import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
	FacebookShareButton,
	LinkedinShareButton,
	TwitterShareButton,
} from 'react-share';

import { BaseApplicationState } from '@common/react/store';
import { BaseUser } from '@common/typescript/objects/BaseUser';

interface Props {
	size?: number;
	defaultHost?: string;
	text?: React.ReactNode;
}

const ShareLinks: React.FC<Props> = ({ size = 36, defaultHost, text }) => {
	const location = useLocation();
	const hostOptions = useSelector((state: BaseApplicationState<BaseUser>) => state.hostOptions);
	const url = `${hostOptions?.item?.hostServer || defaultHost || ''}${location.pathname}`;

	return <div className="share-icons">
		{text}
		<TwitterShareButton
			url={url}
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
				<path
					d="M16.6009 7H19.0544L13.6943 12.9303L20 21H15.0627L11.1957 16.1057L6.77087 21H4.31595L10.049 14.6569L4 7H9.06262L12.5581
					11.4735L16.6009 7ZM15.7399 19.5785H17.0993L8.32392 8.34687H6.86506L15.7399 19.5785Z"
					fill="#2B2A30"
				/>
			</svg>
		</TwitterShareButton>
		<FacebookShareButton
			url={url}
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
				<path
					d="M12.8423 21V12.79H15.4947L15.8926 9.58941H12.8423V7.54632C12.8423 6.61998 13.0889 5.98869 14.3695 5.98869L16 5.98799V3.12531C15.718
					3.08725 14.7501 3 13.6235 3C11.271 3 9.66048 4.49127 9.66048 7.22934V9.58941H7V12.79H9.66048V21H12.8423Z"
					fill="#2B2A30"
				/>
			</svg>
		</FacebookShareButton>
		<LinkedinShareButton
			url={url}
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
				<path
					d="M19.996 21L20 20.9993V15.1313C20 12.2607 19.382 10.0493 16.026 10.0493C14.4127 10.0493 13.33 10.9347
					12.888 11.774H12.8413V10.3173H9.65933V20.9993H12.9727V15.71C12.9727 14.3173 13.2367 12.9707 14.9613 12.9707C16.6607
					12.9707 16.686 14.56 16.686 15.7993V21H19.996ZM4.264 10.318H7.58133V21H4.264V10.318ZM5.92133 5C4.86067 5 4 5.86067
					4 6.92133C4 7.982 4.86067 8.86067 5.92133 8.86067C6.982 8.86067 7.84267 7.982 7.84267 6.92133C7.84231 6.41187 7.63977
					5.92338 7.27953 5.56314C6.91929 5.20289 6.43079 5.00035 5.92133 5Z"
					fill="#2B2A30"
				/>
			</svg>
		</LinkedinShareButton>
	</div>;
};

export default ShareLinks;
